/* bristm-process — section script (loaded only where the section renders) */
(function () {
  function initProcess(scope) {
    var root = scope || document;
    var sections = root.matches && root.matches('[data-b-process]') ? [root] : root.querySelectorAll('[data-b-process]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.bProcessBound) return;
      section.dataset.bProcessBound = '1';
      var steps = section.querySelectorAll('[data-b-step]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!('IntersectionObserver' in window) || reduce) {
        steps.forEach(function (s) {
          s.classList.add('is-in');
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -18% 0px', threshold: 0.2 }
      );
      steps.forEach(function (s) {
        io.observe(s);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProcess(document);
    });
  } else {
    initProcess(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initProcess(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-b-step]');
    if (step) step.classList.add('is-in');
  });
})();
